<template>
  <v-dialog v-model="dialog" persistent width="1500">
    <common-card>
      <CommondLoading
        v-if="loadingModal"
        :loadingImage="dataLoading.inter"
        :show="loadingModal"
        loadingText="Cargando info"
      />
      <v-card-text class="pa-4 black--text" v-else>
        <div
          class="pt-5 pb-5 top-text"
          style="width: 100%; height: 100%; justify-content: center; text-align: center;"
        >
          {{ idCampaing ? "Edicion" : "Creación" }} de campaña PostVenta Inbound
        </div>
        <div class="pt-5 pb-5">
          <CreatePostVenta
          :toSave="toSave"
          @goTosave="goTosave"
          :cuentaId="idCampaing"
          :readOnly="readOnly"
        />
        </div>
        <div>
          <v-row style="text-align: end;">
            <v-col cols="12">
              <v-btn
                text
                color="#00a7e4"
                outlined
                dark
                style="border-radius: 15px;"
                @click="$emit('closeModal')"
              >
                Cancelar</v-btn
              >
              <v-btn class="common-botton" dark @click="toSave = true"
                >Guardar</v-btn
              >
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <CommonActionModal :dialog="dialogEleccion" title="Crear la Campaña Inbound"
        subtitle="¿Deseas crear esta campaña?" bottonText="Si, creala" @userChoice="postPutCampaniaInbound" />
    </common-card>
  </v-dialog>
</template>

<script>
import CreatePostVenta from "@/components/commonComponents/forms/CreatePostVenta.vue";
import CommonActionModal from "@/components/commonComponents/CommonActionModal.vue";
import CommonCard from "../CommonCard.vue";
import { postCrearCampaniaInbound, updateCampaniaInbound } from "@/services/campañasPostVentaInbound/CampañasPostVentaInbound";
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    idCampaing: {
      type: Number,
      default: 0,
    },
  },
  components: {
    CreatePostVenta, CommonCard,
    CommonActionModal,
  },
  data() {
    return {
      toSave: false,
      dialogEleccion: false,
      form: {},
      cuentaId: this.$route.params.id,
      loadingModal: false,
    };
  },
  methods: {
    async getData() {
      this.loadingModal = false
    },
    goTosave(result, form) {
      if (result) this.dialogEleccion = true;
      this.form = form;
      this.toSave = false;
    },
    postPutCampaniaInbound(val) {
      this.dialogEleccion = false;
      if (val) {
        if (!this.cuentaId) this.postCrearCampaniaInbound();
        else this.editCampaniaInboundByID();
      }
    },
    async postCrearCampaniaInbound() {
      const finalform = {
        ...this.form
      };

      try {
        await postCrearCampaniaInbound(finalform);
        this.$toast.success("Campaña creada con éxito");
        this.$emit("closeModal");
        this.dialogEleccion = false;
      } catch (error) {
        this.$toast.error("Ocurrió un error al crear la campaña");
        this.dialogEleccion = false;
      }
    },
    async editCampaniaInboundByID() {
      const finalform = {
        ...this.form
      };

      try {
        await updateCampaniaInbound(finalform, this.cuentaId);
        this.$toast.success("Campaña editada con éxito");
        this.$emit("closeModal");
        this.dialogEleccion = false;
      } catch (error) {
        this.$toast.error("Ocurrió un error al crear la campaña");
        this.dialogEleccion = false;
      }
    },
  },
  mounted() {
    if (this.idCampaing) this.getData();
  },
};
</script>

<style>
.v-toolbar--dense .v-toolbar__content,
.v-toolbar--dense .v-toolbar__extension {
  padding-top: 0;
  padding-bottom: 0;
  justify-content: center;
}

.top-text {
  width: 369px;
  height: 22px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 110%;
  display: flex;
  align-items: center;
  text-align: center;
  color: #4d5358;
  flex: none;
  order: 0;
  flex-grow: 1;
}

.confirmation-text {
  /* Por favor, asegúrate de revisar cuidadosamente los cambios antes de continuar */

  width: 369px;
  height: 30px;

  /* Subtitle/S */
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 110%;
  /* or 15px */
  text-align: center;

  color: #555555;

  /* Inside auto layout */
  flex: none;
  order: 2;
  align-self: stretch;
  flex-grow: 0;
}
</style>
